import { render } from "./PageAccueil.vue?vue&type=template&id=661d1492&scoped=true"
import script from "./PageAccueil.vue?vue&type=script&lang=js"
export * from "./PageAccueil.vue?vue&type=script&lang=js"

import "./PageAccueil.vue?vue&type=style&index=0&id=661d1492&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661d1492"]])

export default __exports__